export const LIST_INITIAL_PAGE_SIZE = 10;
export const LIST_INITIAL_PAGE = 1;
export const LIST_INITIAL_TOTAL = 0;
export const LIST_INITIAL_TOTAL_PAGES = 1;

export const LIST_INITIAL_PAGINATION = {
  page: LIST_INITIAL_PAGE,
  pageSize: LIST_INITIAL_PAGE_SIZE,
  total: LIST_INITIAL_TOTAL,
  totalPages: LIST_INITIAL_TOTAL_PAGES,
};

export const LIST_INITIAL_CURSOR = '';
export const LIST_INITIAL_HAS_NEXT_PAGE = false;
export const LIST_INITIAL_HAS_PREVIOUS_PAGE = false;

export const LIST_INITIAL_KEYSET_PAGINATION = {
  pageSize: LIST_INITIAL_PAGE_SIZE,
  hasNextPage: LIST_INITIAL_HAS_NEXT_PAGE,
  hasPreviousPage: LIST_INITIAL_HAS_PREVIOUS_PAGE,
  startCursor: LIST_INITIAL_CURSOR,
  endCursor: LIST_INITIAL_CURSOR,
};
